import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUploadPhoto = ({ id, invalidateUserData = true } = {}) => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ file, userId }) => {
      const targetId = userId || id;
      const formData = new FormData();
      formData.append('file', file);
      if (targetId) {
        formData.append('key', targetId);
      }
  
      const result = await restClient({ 
        url: `${prefix}/profile/photo`, 
        method: 'put',
        data: formData,
      });
      return result;
    },
    onSuccess: async () => {
      if (invalidateUserData) {
        await queryClient.invalidateQueries(['userData']);
      }
    }
  });
};
